// extracted by mini-css-extract-plugin
module.exports = {"navlinksList":"NavLinks_navlinksList__3UL5M","mobileLinks":"NavLinks_mobileLinks__1661m","navlinksListItemLink":"NavLinks_navlinksListItemLink__334bC"};